import apiClient from "@/utils/apiClient";

export const activityCatalogService = {
  /* Upload activity image */
  uploadImage: async (formData) => {
    const response = await apiClient.post("/activity-catalog/upload-image", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  /* Get filtered activities */
  getActivities: async (params = {}) => {
    const response = await apiClient.get("/activity-catalog", { params });
    return response.data;
  },

  /* Get distinct destinations list */
  getDestinations: async () => {
    const response = await apiClient.get("/activity-catalog/destinations");
    return response.data;
  },

  /* Create single activity */
  createActivity: async (data) => {
    const response = await apiClient.post("/activity-catalog", data);
    return response.data;
  },

  /* Update single activity */
  updateActivity: async (id, data) => {
    const response = await apiClient.put(`/activity-catalog/${id}`, data);
    return response.data;
  },

  /* Delete single activity */
  deleteActivity: async (id) => {
    const response = await apiClient.delete(`/activity-catalog/${id}`);
    return response.data;
  },

  /* Bulk delete activities */
  bulkDeleteActivities: async (ids) => {
    const response = await apiClient.post("/activity-catalog/bulk-delete", { ids });
    return response.data;
  },

  /* Bulk upload activities */
  bulkUploadActivities: async (activities, defaultDestination = "") => {
    const response = await apiClient.post("/activity-catalog/bulk-upload", {
      activities,
      defaultDestination,
    });
    return response.data;
  },
};

export default activityCatalogService;
